<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div appMargin marginB="5">
    <button
      class="ui primary tiny button"
      (click)="collapseEquipment = !collapseEquipment"
    >
      Add Application
      <i
        [ngClass]="collapseEquipment ? 'chevron down icon' : 'chevron up icon'"
      ></i>
    </button>
  </div>
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>
  <div [suiCollapse]="collapseEquipment">
    <div
      class="ui segment form"
      [formGroup]="newForm"
      [ngClass]="{ loading: pending }"
    >
      <div class="fields">
        <div
          class="seven wide field required"
          [ngClass]="displayFieldCss('applicationId')"
        >
          <label>Select Application</label>
          <select formControlName="applicationId">
            <option *ngFor="let role of apps" value="{{ role.applicationId }}">
              {{ role.applicationName }}
            </option>
          </select>
        </div>
        <!-- <div class="seven wide field" [ngClass]="displayFieldCss('role')">
                         <label>Select Role</label>
				<select formControlName="role">
                              <option *ngFor="let role of roles" value="{{role.roleId}}">{{role.roleName}}</option>
                        </select>
                        </div> -->
        <div class="four wide field" [ngClass]="displayFieldCss('owner')">
          <label>Is Owner</label>
          <sui-checkbox formControlName="owner"></sui-checkbox>
        </div>
      </div>
      <div class="fields">
        <button
          class="ui fluid green button"
          [disabled]="!newForm.valid"
          (click)="submit()"
        >
          Add Application to Department
        </button>
      </div>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
    <div fxFlex="grow">
      <h4 class="sub-header">App Name</h4>
    </div>
    <!-- <div fxFlex="30%">Role</div> -->
    <div fxFlex="20%">Is Owner</div>
    <div fxFlex="10%"></div>
  </div>
  <hr />
  <div
    class="scroll-wrapper vertical ui basic segment"
    [ngClass]="{ loading: pending }"
  >
    <div
      class="ui segment"
      *ngFor="let document of applications"
      appMargin
      marginB="5"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayoutGap="15px"
      >
        <div fxFlex="grow">
          <h4 class="sub-header">{{ document?.applicationName }}</h4>
        </div>
        <!-- <div fxFlex="30%">
          {{ getRoleName(document?.appRole) }}
        </div> -->
        <div fxFlex="20%">
          <span
            class="ui red label"
            [ngClass]="{ green: document.owner == true }"
          >
            {{ document?.owner }}</span
          >
        </div>
        <div fxFlex="10%">
          <button class="ui tiny icon button" (click)="onDelete(document)">
            <i class="ui trash icon"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="save()"
    autofocus
  >
    Done
  </button>
</div>
